<template>
  <div class="exchang">
    <button
      class="button exchang_bg exchang_left"
      @click="$emit('oneexchange')"
    >
      <div class="exchang_num">1个幸运码</div>
      <div
        class="exchang_sumbit"
        :class="{
          exchang_sumbit_gray: !isExchange,
          exchang_sumbit_red: isExchange
        }"
      >
        <img
          class="exchang_image"
          src="../../assets/lottery/integral_icon.png"
        />
        <div class="exchang_image_title">100</div>
      </div>
    </button>
    <button
      class="button exchang_bg exchang_right"
      @click="$emit('tenexchange')"
    >
      <div class="exchang_num">10个幸运码</div>
      <div
        class="exchang_sumbit"
        :class="{
          exchang_sumbit_gray: !isExchange,
          exchang_sumbit_red: isExchange
        }"
      >
        <img
          class="exchang_image"
          src="../../assets/lottery/integral_icon.png"
        />
        <div class="exchang_image_title">1000</div>
      </div>
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  emits: {
    oneexchange: () => {
      return true;
    },
    tenexchange: () => {
      return true;
    }
  }
})
export default class Exchange extends Vue {
  // 是否可兑换幸运码 （星期天不能在兑换幸运码）
  private isExchange = true;
  mounted() {
    const now = new Date();
    /// 是否是星期天
    if (now.getDay() == 0) {
      this.isExchange = false;
    } else {
      this.isExchange = true;
    }
  }
}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.exchang {
  overflow: hidden;
  margin-top: 11px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  text-decoration: none;
  overflow: hidden;

  .exchang_bg {
    width: ~"calc((100% - 51px) / 2)";
    height: 88px;
    background-color: white;
    border-radius: 10px;
    overflow: hidden;
  }
  .exchang_left {
    margin: 0px 0px 0px 20px;
    float: left;
  }
  .exchang_right {
    margin: 0px 20px 0px 0px;
    float: right;
  }
  .exchang_num {
    margin: 0px 0px 10px 0px;
    font-size: 14px;
    font-weight: bold;
    line-height: 15px;
    // background-color: yellow;
  }
  .exchang_sumbit_gray {
    background-color: #cccccc;
  }
  .exchang_sumbit_red {
    background-color: #f64746;
  }
  .exchang_sumbit {
    margin: auto 17%;
    width: 66%;
    height: 28px;
    border-radius: 30px;
    align-items: center;
    text-align: center;

    .exchang_image {
      float: left;
      width: 24px;
      height: 24px;
      margin: 1px auto;
      margin-left: 20%;
      margin-right: 5%;
    }
    .exchang_image_title {
      float: left;
      margin: 4px auto;
      color: #ffffff;
      font-size: 13px;
      line-height: 20px;
      // background-color: yellow;
    }
  }
}
</style>
